module.exports = __webpack_public_path__ + "img/cards.6947842.svg";